module.exports = __webpack_public_path__ + "static/fonts/iconfont.653978da.woff2";